import style from 'styled-components';

export const GoogleBtnWrapper = style.div`
    min-width: 250px;
    height: 48px;

    .google-pay-button-container {
        width: 100%;
        height: 48px;
    }

    .gpay-card-info-container,
    .gpay-button {
        border-radius: 12px;
    }
`;

